import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { Document, Image, Page, pdf, Text, View } from '@react-pdf/renderer';
import { Emissionsfaktoren } from './Emissionsfaktoren';
import { Heizwerte } from './Heizwerte';
import { IDs } from '../../helpers/IDs';
import * as Moment from 'moment';
import { parsePdfSub2 } from '../datenauswertung/generisch/helper';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import style from '../../default.less';
import { WActionButton } from '../../core/elements/WActionButton';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
export interface EmissionsfaktorenHeizwerteProps {
    data: any;
}

export interface EmissionsfaktorenHeizwerteState {
    isLoading: boolean;
    jahr: number;
    jahrMax: number;
    jahrMin: number;
}

export class EmissionsfaktorenHeizwerte extends React.Component<EmissionsfaktorenHeizwerteProps, EmissionsfaktorenHeizwerteState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            jahr: null,
            jahrMax: null,
            jahrMin: null
        };
    }

    componentDidMount(): void {
        this.getJahre();
    }

    getJahre(): void {
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;
        this.setState({ jahr: jahrMax, jahrMax, jahrMin });
    }

    getStyle(isPdf?: boolean): any {
        const width: number = isPdf ? 555 : 655;
        const colorSection: string = new SectionStyle().getPropertyValue('--color-section-main');

        return ({
            main: {
                minWidth: width,
                maxWidth: width,
                ...(!isPdf && { margin: '0 0 0 20px' }),
                display: 'flex',
                flexDirection: 'column'
            },
            header: {
                fontSize: '18pt',
                fontFamily: 'Helvetica-Bold',
                color: '#555',
                width: '100%',
                height: 85,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relatitive',
                display: 'block'
            },
            headerImage: {
                width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerText: {
                marginTop: -3
            },
            headerSubText: {
                fontSize: '16pt',
                color: colorSection || '#5e8bc2'
            },
            headerSubText2: {
                fontSize: '13pt',
                color: '#333',
                marginTop: 8
            },
            footer: {
                fontSize: '8pt',
                right: 20,
                bottom: 15,
                left: 20,
                width: '100%',
                height: 'auto',
                padding: 0,
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            footerSeiten: {
                right: 0,
                position: 'absolute'
            },
            actions: {
                backgroundColor: '#eee',
                maxWidth: '100%',
                top: 0,
                position: 'sticky',
                zIndex: 1,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'baseline',
                padding: '5px'
            },
            page: {
                padding: 20
            }
        });
    }

    async processPdf(pdfData: JSX.Element): Promise<void> {
        try {
            const blob = await pdf(pdfData).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            this.setState({ isLoading: false });
            const filename: string = (
                'Emissionsfaktoren+Heizwerte [' +
                (new Date()).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
                '].pdf'
            );
            // const a = document.createElement('a');
            // a.target = '_blank';
            // a.title = filename;
            // a.href = pdfString;
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(pdfString, filename);
        } catch (error) {
            console.log('error: ', error);
        }
    }

    render(): JSX.Element {
        if (!this.state.jahr) {
            return <div>Lade...</div>;
        }
        const styles: any = this.getStyle();

        return (
            <>
                <div style={styles.main}>
                    <div style={{ ...styles.actions, flex: 'unset' }}>
                        {this.renderJahresauswahl()}
                        {this.renderPdfButton()}
                    </div>
                    <div style={{ marginTop: 40 }}>
                        <Emissionsfaktoren
                            data={this.props.data}
                            jahr={this.state.jahr}
                        />
                        <div style={{ marginTop: 40 }} />
                        <Heizwerte
                            data={this.props.data}
                            jahr={this.state.jahr}
                        />
                    </div>
                </div>
                {this.state.isLoading && <WSpinner label='PDF...' />}
            </>
        );
    }

    renderFooter(): JSX.Element {
        const styles: any = this.getStyle(true);

        return (
            <View style={styles.footer} fixed>
                <Text>
                    {Moment().format('DD.MM.YYYY')}
                </Text>
                <View style={(styles.footerSeiten || {})}>
                    <Text
                        render={({ pageNumber, totalPages }) => {
                            if (totalPages > 1) {
                                return `${pageNumber}/${totalPages}`;
                            }
                        }}
                        fixed
                    />
                </View>
            </View>
        );
    }

    renderHeader(): JSX.Element {
        const header = require('../../img/logo_mittel2.png');
        const styles: any = this.getStyle(true);
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;

        return (
            <View style={styles.header} fixed>
                <Text style={styles.headerText}>E-Tool</Text>
                <Text style={styles.headerSubText}>
                    {parsePdfSub2(unternehmen, styles.headerSubText2)}
                </Text>
                <Text style={styles.headerSubText2}>
                    Emissionsfaktoren und Heizwerte relevanter Energieträger
                </Text>
                <Image src={header} style={styles.headerImage} />
            </View>
        );
    }

    renderJahresauswahl(): JSX.Element {
        return (
            <DatenauswertungJahrauswahlEinzeln
                jahrMin={this.state.jahrMin}
                jahrMax={this.state.jahrMax}
                jahr={this.state.jahr}
                onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                className={style.noarrows}
            />
        );
    }

    async renderPdf(): Promise<void> {
        const styles: any = this.getStyle(true);
        this.processPdf(
            <Document>
                <Page size='A4' orientation='portrait' style={styles.page}>
                    {this.renderHeader()}
                    <View>
                        <Emissionsfaktoren
                            data={this.props.data}
                            jahr={this.state.jahr}
                            isPdf
                        />
                    </View>
                    {this.renderFooter()}
                </Page>
                <Page size='A4' orientation='portrait' style={styles.page}>
                    {this.renderHeader()}
                    <View>
                        <Heizwerte
                            data={this.props.data}
                            jahr={this.state.jahr}
                            isPdf
                        />
                    </View>
                    {this.renderFooter()}
                </Page>
            </Document>
        );
    }

    renderPdfButton(): JSX.Element {
        return (
            <WActionButton
                label='PDF generieren'
                insideText='PDF generieren'
                key='pdf'
                action='pdf'
                onAction={() => this.setState({ isLoading: true }, this.renderPdf)}
            />
        );
    }
}
